import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'
import theme from '@theme/Theme'

import Root from '@components/root/Root'
import Icon from '@components/icon/Icons'
import Loader from '@components/loader/Loader'
import Button from '@components/button/Button'

import api from '@api/api'
import Logger from '@utils/logger'

import * as AuthStore from '@store/auth/auth'
import * as UserStore from '@store/user/user'
import { onNewUser } from '@store/store'
import useReducer from '@store/useReducer'

import useI18n from '@i18n/useI18n'
import useNavigation from '@layout/useNavigation'

interface Props {
  service_name: string
  token: string
  token_expire_date: string
}

const LoginSsoCallbackScreen = ({ token }: Props) => {
  const i18n = useI18n()
  const navigation = useNavigation()

  const lastUser = useReducer(UserStore.store, (s) => s.lastUser)

  const [status, setStatus] = React.useState<Status>('loading')

  React.useEffect(() => {
    if (!token) {
      setStatus('error')
    } else {
      api.authentification
        .ssoToken({ token })
        .then((res) => {
          AuthStore.actions.setTokens({
            access: res.access_token,
            expireIn: res.expires_in,
            scopes: res.scopes,
            refresh: res.refresh_token,
          })

          AuthStore.actions.setScopes(res.scopes)
        })
        .then(api.authentification.me)
        .then((user) => {
          if (lastUser !== user.id) {
            // reset saved datas
            onNewUser()
          }

          // set user
          UserStore.actions.setUser(user)
        })
        .then(() => UserStore.actions.setLogged(true))
        .then(api.incident.followed)
        .then(UserStore.actions.setFavoriteIncidents)
        .catch((err) => {
          Logger.error(err)
          setStatus('error')
        })
    }
  }, [])

  return (
    <Root>
      <Container>
        {status === 'loading' ? (
          <Loader color={theme.colors.primary} />
        ) : (
          <Icon name="viparis" size={48} color={theme.colors.primary} />
        )}
        <Message>{i18n.t(status === 'error' ? 'screens.loginSso.error' : 'screens.loginSso.loading')}</Message>
        {status === 'error' && (
          <ButtonContainer>
            <Button status="active" label={i18n.t('screens.loginSso.goBack')} onClick={() => navigation.reset()} />
          </ButtonContainer>
        )}
      </Container>
    </Root>
  )
}

export default LoginSsoCallbackScreen

const Container = styled(View)`
  padding: 148px 16px;
  justify-content: center;
  align-items: center;
`

const Message = styled(Text)`
  ${(props) => props.theme.fonts.Title2};
  text-align: center;
  margin-top: 24px;
`

const ButtonContainer = styled(View)`
  width: 250px;
  margin-top: 50px;
`
